/** 租户用能账单 /metering/bill/energy-bill-tenant（energyBill.vue） */
export default {
  energyBillPage: {
    phDateStart: '开始日期',
    phDateEnd: '结束日期',
    phTenant: '租户名称/编号',
    phTenantType: '租户类型',
    tenantType0: '租户',
    tenantType1: '公区',
    tenantType2: '其他',
    tenantType3: '光伏',
    phBillType: '费用类型',
    phSettleWay: '账单类型',
    phPayType: '付费模式',
    billTypeElectric: '电费',
    billTypeWater: '水费',
    billTypeService: '服务费',
    settleWay0: '普通结算',
    settleWay1: '手动扣款',
    settleWay2: '系统补单',
    settleWay3: '浮动电价',
    settleWay4: '分摊结算',
    settleWay5: '设备扣款',
    settleWay10: '租户充值',
    optPayPrepaid: '预付费',
    optPayPostpaid: '后付费',
    btnSearch: '查询',
    btnReset: '重置',
    btnExport: '导出',
    exportCurrentPage: '导出本页',
    exportSelected: '导出选中',
    exportAll: '导出全部',
    warnNoSelectedExport: '请先勾选要导出的数据',
    btnExpand: '展开',
    btnCollapse: '收起',
    tooltipMeterElec: '表计电费：',
    tooltipOtherElec: '其他电费：',
    tooltipMeterWater: '表计水费：',
    tooltipOtherWater: '其他水费：',
    tooltipTotal: '合计：',
    statElectricity: '电费',
    statWater: '水费',
    statServiceFee: '服务费',
    statGrandTotal: '合计',
    sectionTitle: '租户账单',
    sortDefault: '默认排序',
    selectedLine: '已选择 <span class="count">{count}</span> 条数据',
    payPaid: '已缴费',
    payUnpaid: '未缴费',
    colAction: '操作',
    btnDetail: '详情',
    shortcut7d: '最近7天',
    shortcut15d: '最近15天',
    shortcut30d: '最近30天',
    shortcutThisMonth: '本月',
    shortcutLastMonth: '上月',
    colRid: '账单编号',
    colOccurDate: '账单日期',
    colCreateTime: '创建时间',
    colTenantInfo: '租户信息',
    colPayType: '付费模式',
    colBillType: '费用类型',
    colSettleWay: '账单类型',
    colBalance: '账单金额',
    colPayStatus: '缴费状态',
    colDiscountAmt: '抵扣金支付(元)',
    colRealAmt: '现金支付(元)',
    colStatus: '开票状态',
    invoice0: '未开票',
    invoice1: '审核中',
    invoice2: '已开票',
    invoice3: '已拒绝',
    msgFetchListFail: '获取数据失败',
    msgFetchBillFail: '获取账单数据失败',
    msgExportListFail: '获取导出数据失败',
    msgNoDataExport: '暂无数据可导出',
    exportLoading: '正在加载全部账单用于导出，请稍候…',
    msgNoRowsExport: '暂无可导出数据',
    msgExportFail: '导出失败，请重试',
    msgExportOk: '成功导出{count}条数据！',
    msgExportOkSelected: '成功导出{count}条选中数据！',
    successExported: '成功导出 {count} 条数据',
    successExportedLimit: '共 {total} 条，已导出前 {count} 条',
    exportSheetName: '能耗账单',
    filePrefix: '租户账单',
    billTypeUseWater: '水费',
    billTypeUseElectric: '电费',
    billTypeUseService: '服务费'
  }
}
